import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { TAB_DATA } from "../constants/Webchat/WebchatTabInfo";

export const useActiveTab = () => {
    const history = useHistory();
    const location = useLocation();

    const [activeTab, setActiveTab] = useState('');

    useEffect(() => {
        const determineActiveTab = async () => {
            try {
                let currentPath = location.pathname;
                const matchingTab = Object.values(TAB_DATA).find(tab => tab.route === currentPath);
                if (matchingTab) {
                    setActiveTab(matchingTab);
                    return;
                } else {
                    console.error(`No matching tab found for path: ${currentPath}`);
                    setActiveTab('ERROR');
                }
            } catch (err) {
                console.error(`Error finding matching tab`, err);
                setActiveTab("ERROR");
            }
        };

        determineActiveTab();
    }, [history, location.pathname]);

    return activeTab;
}